import { CookieFunctions } from './cookiemessage';
declare const IS_DEV_BUILD: boolean; // The value is supplied by Webpack during the build
declare const VERSION: string; // The value is supplied by Webpack during the build
import * as Sentry from '@sentry/browser';
// import { Integrations } from '@sentry/tracing';
// import { RewriteFrames } from '@sentry/integrations';

if (!IS_DEV_BUILD) {

  Sentry.init({
    dsn: 'https://68dc5a7baeed492e81f53b29c14868e7@o460993.ingest.sentry.io/5462155',
    release: `v-${VERSION}`,
    // integrations: [new Integrations.BrowserTracing()],
    // tracesSampleRate: 0.25,
    // debug: true,
    // beforeSend(event) {
    //  alert('Event!');
    //  console.log(event);
    //  return event;
    // },
  });

} else {

  // Sentry.init({
  //  dsn: 'https://a14734e2f34e483fb65ac3c289bec28e@o460993.ingest.sentry.io/5462176',
  //  release: `v-${VERSION}`,
  //  integrations: [new Integrations.BrowserTracing()],
  //  tracesSampleRate: 1.0,
  // });
}

export class CookieSetup {

  public cookieFunctions: CookieFunctions;

  constructor() {
    this.cookieFunctions = new CookieFunctions;
  }

}

const cookieSetupJs = new CookieSetup();
cookieSetupJs.cookieFunctions.setupMessage();
